import { getMapObjects, type TiledMap } from '@veriverse/map-format';
import { TILE_SIZE } from '@veriverse/shared';
import type Phaser from 'phaser';
import catIdle from '../../../../assets-src/concept/cat-scholes/cat-scholes-idle.png';
import { spriteDepth } from './depth.js';

/**
 * Cat Scholes in the office (style guide §6): a 32×32 sprite on every `cat_spot` object, anchored
 * bottom centre and depth-sorted like characters. Until the art is approved this is the concept
 * idle strip (7 frames, 8 fps); with reduced motion it holds the first frame.
 */
export const CAT_IDLE_SHEET = catIdle;
export const CAT_IDLE_FRAMES = 7;
const CAT_FPS = 8;
const SHEET_KEY = 'cat-scholes:idle';
const ANIMATION_KEY = 'cat-scholes:idle';

export function loadCatScholes(scene: Phaser.Scene): void {
  scene.load.spritesheet(SHEET_KEY, catIdle, { frameWidth: TILE_SIZE, frameHeight: TILE_SIZE });
}

export function addCatScholes(
  scene: Phaser.Scene,
  map: TiledMap,
  reducedMotion: boolean,
): Phaser.GameObjects.Sprite[] {
  if (!scene.textures.exists(SHEET_KEY)) return [];
  if (!reducedMotion && !scene.anims.exists(ANIMATION_KEY)) {
    scene.anims.create({
      key: ANIMATION_KEY,
      frames: scene.anims.generateFrameNumbers(SHEET_KEY, { start: 0, end: CAT_IDLE_FRAMES - 1 }),
      frameRate: CAT_FPS,
      repeat: -1,
    });
  }
  return getMapObjects(map)
    .filter((object) => object.type === 'cat_spot')
    .map((object) => {
      const { x, y, w, h } = object.footprint;
      const sprite = scene.add
        .sprite((x + w / 2) * TILE_SIZE, (y + h) * TILE_SIZE, SHEET_KEY, 0)
        .setOrigin(0.5, 1)
        .setDepth(spriteDepth(y + h - 1));
      if (!reducedMotion)
        sprite.play({ key: ANIMATION_KEY, startFrame: object.id % CAT_IDLE_FRAMES });
      return sprite;
    });
}
